import { View } from "@-/com.npmjs.react-native";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import {
  SectionAccordionNodes,
  SectionAccordionTab,
} from "@-/dev.improve.haniverse.components.ui.section-accordion";
import { useIsActorSyncPreparing } from "@-/dev.improve.haniverse.routes.nav._context";
import { useSyncStatus } from "@-/dev.improve.haniverse.lib.sync-client";
import { useHasHydrated } from "@-/dev.improve.haniverse.lib.hydration";
import type { ComponentProps } from "react";

type PlaceholderSection = Pick<
  ComponentProps<typeof SectionAccordionNodes>,
  "bodyKey" | "headerKey" | "iconName" | "title"
>;

/** Page content only: layout-owned navigation stays mounted and interactive. */
export function ActorSyncPlaceholder({
  background = "background",
  sections,
}: {
  background?: "background" | "muted";
  sections: readonly PlaceholderSection[];
}) {
  const isSyncing = useIsActorSyncPreparing();
  const hasHydrated = useHasHydrated();
  const { syncedEntryCount } = useSyncStatus();
  return (
    <SectionAccordionTab
      className={background === "background" ? "bg-background" : undefined}
      contentContainerClassName={background === "background" ? "bg-background" : undefined}
      contentInsetAdjustmentBehavior={background === "background" ? "automatic" : undefined}
    >
      {sections.map((section, index) => (
        <SectionAccordionNodes
          {...section}
          // The server has no device account; expand client sync details after hydration.
          isOpen={hasHydrated && isSyncing && index === 0}
          isPlaceholder
          key={section.headerKey}
          onToggle={() => {}}
        >
          <View className="gap-2 p-4">
            <Text>Syncing data from cloud...</Text>
            {syncedEntryCount != null ? (
              <Text className="text-sm text-muted-foreground">
                {syncedEntryCount.toLocaleString()} entries available locally
              </Text>
            ) : null}
          </View>
        </SectionAccordionNodes>
      ))}
    </SectionAccordionTab>
  );
}
